import React, { Component } from 'react';

import { Row, Col } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/TimeLine.css";

import timeLinePic from "../../../Imgs/AboutUs/Introduction/timeLine.png";
import timeLineMobilePic from "../../../Imgs/AboutUs/Introduction/timeLineMobile.png";


const TimeLine = props => {
    
     return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
			<Center>
				<Margin top={5}>
				<div>
					<p className="subTitle"><strong>گاهشمار</strong></p>
				</div>
               </Margin>
            </Center>
            <Center>
				<div className="subTitleHR"></div>
            </Center>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
				<Center>
                         <LazyLoad>
					<img
						style={{ width: "100%" }}
						src={timeLinePic}
					/>
                         </LazyLoad>
				</Center>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
     ) : props.size === "tablet" ? (
            <div>
                <Center>
				<Margin top={5}>
				<div>
					<p className="subTitleTablet"><strong>گاهشمار</strong></p>
				</div>
               </Margin>
            </Center>
            <Center>
				<hr className="subTitleHRTablet" />
            </Center>
            <Row>
                <Col span={2}></Col>
                <Col span={20}>
				<Center>
                         <LazyLoad>
					<img
						style={{ width: "100%" }}
						src={timeLinePic}
					/>
                         </LazyLoad>
				</Center>
                </Col>
                <Col span={2}></Col>
            </Row>
            </div>

     ) : (
            <div>
                <Center>
				<Margin top={4}>
				<div>
					<p className="subTitleMobile"><strong>گاهشمار</strong></p>
				</div>
               </Margin>
            </Center>
            <Center>
				<div className="subTitleHRMobile"></div>
            </Center>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
				<Center>
                         <LazyLoad>
					<img
						style={{ width: "100%" }}
						src={timeLineMobilePic}
					/>
                         </LazyLoad>
				</Center>
                </Col>
                <Col span={4}></Col>
            </Row>
            </div>
          );
};

export default TimeLine;
